// CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
// eslint-disable-line

class StaticProductRecommendations {
    constructor(section) {
        this.section = section;
        this.productId = section.data.productId;
        this.recommendedProducts = [];
        this.productsScroller = null;
        this.sectionId = section.data.sectionId;
        this.recommendationContainer = document.querySelector(
            "[data-product-recommendations]"
        );
        this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=${this.sectionId}&product_id=${this.productId}`;
        this._loadRecommendations = this._loadRecommendations.bind(this);
        this._resizeRowScroller = this._resizeRowScroller.bind(this);
        this._loadRecommendations();
    }
    _loadRecommendations() {
        shopify_asyncview_dist_index_es
            .load(this.recommendUrl, {
                view: "",
            })
            .then((_ref) => {
                let { html } = _ref;
                this.recommendationContainer.innerHTML = html;
                dist_index_es.watch(this.recommendationContainer);
                const productItems =
                    this.recommendationContainer.querySelectorAll(
                        "[data-product-item]"
                    );
                const productItemLazyLoad = Layout.isGreaterThanBreakpoint(
                    "L",
                    true
                );
                if (productItems.length) {
                    productItems.forEach((productItem) => {
                        this.recommendedProducts.push(
                            new ProductGridItem({
                                el: productItem,
                                id: this.section.id
                            })
                        );
                    });
                    initShopifyProductReviews();
                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                        setTimeout(() => {
                            window.dispatchEvent(
                                new Event("custom:payment-btn-init")
                            );
                        }, 0);
                    }
                    this.recommendationContainer.addEventListener(
                        "rimg:load",
                        this._resizeRowScroller
                    );
                    this.productsScroller = new ProductRowScroller(
                        this.section.el.querySelector("[data-product-row]")
                    );
                } else {
                    this.recommendationContainer.innerHTML = '';
                }
            });
    }
    _resizeRowScroller() {
        if (this.productsScroller && this.productsScroller.flickity) {
            this.productsScroller.flickity.resize();
        }
    }
    onSectionUnload() {
        if (this.productsScroller) {
            this.productsScroller.unload();
        }
        this.recommendedProducts.forEach((productItem) => {
            productItem.unload();
        });
        this.recommendationContainer.removeEventListener(
            "rimg:load",
            this._resizeRowScroller
        );
    }
}

sections.register(
    "static-product-recommendations",
    (section) => new StaticProductRecommendations(section)
);
